'use client'

import { FC, useEffect, useState } from 'react'
import Confetti from 'react-confetti'

interface ProgressConfettiProps {
  show: boolean
  duration?: number
}

export const ProgressConfetti: FC<ProgressConfettiProps> = ({ show }) => {
  const [showConfetti, setShowConfetti] = useState(false)

  useEffect(() => {
    if (show) {
      setShowConfetti(true)
    } else {
      setShowConfetti(false)
    }
  }, [show])

  if (!showConfetti) return null

  const confettiSource = {
    x: 0,
    y: window.scrollY,
    w: window.innerWidth,
    h: 0
  }

  return (
    <Confetti
      width={window.innerWidth}
      height={window.innerHeight + window.scrollY}
      recycle={false}
      numberOfPieces={800}
      gravity={0.2}
      tweenDuration={3000}
      initialVelocityY={-12}
      onConfettiComplete={() => {
        setShowConfetti(false)
      }}
      confettiSource={confettiSource}
    />
  )
}
